export default __webpack_public_path__ + "static/avatar-7a17ad9439ba86f6658ef28be028d64d.jpeg";